var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangePlantation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2177 17.5C13.2864 17.5 17.0644 17.7304 20 13.5C22 10.618 21.5613 7.4642 21.4135 6.74735C19 6.24965 14.5776 6.25024 12.1044 11.0484M11.2177 17.5C11.9269 14.4035 15.0596 11.6218 16.5373 10.618M11.2177 17.5C11.2177 16.5294 11.2566 15.6701 11.3194 14.9191M11.2177 17.5L11.2185 17.25C7.66611 16.3409 2.79521 15.75 2.79517 7.17746C6.25 7.17746 9.62196 7.95165 12.1044 11.0484M12.1044 11.0484C11.8846 11.4748 11.5014 12.7415 11.3194 14.9191M6.7849 11.0481C7.29589 12.0517 8.91817 14.2309 11.3194 14.9191",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePlantation);
export default __webpack_public_path__ + "static/media/orange_plantation.065dd5e288efea670af261f36fce6c22.svg";
export { ForwardRef as ReactComponent };